export enum Regions {
    TjumenskajaOblast = 'Тюменская область',
    KurganskajaOblast = 'Курганская область',
    OrenburgskajaOblast = 'Оренбургская область',
    SverdlovskajaOblast = 'Свердловская область',
    Surgut = 'Сургут',
    JaNAO = 'ЯНАО',
    UGRA = 'ЮГРА',
    NRIC = 'НРИЦ',
}

export const activeRegionsList: Regions[] = [
    Regions.TjumenskajaOblast,
    Regions.KurganskajaOblast,
    Regions.OrenburgskajaOblast,
    Regions.SverdlovskajaOblast,
    Regions.Surgut,
    Regions.JaNAO,
    Regions.UGRA,
    Regions.NRIC,
];

export const regionsBillingDictionary: Record<Regions, string> = {
    [Regions.TjumenskajaOblast]: 'TYUMEN',
    [Regions.OrenburgskajaOblast]: 'ORENBURG',
    [Regions.Surgut]: 'SURGUT',
    [Regions.JaNAO]: 'JANAO',
    [Regions.KurganskajaOblast]: 'KRUGAN',
    [Regions.SverdlovskajaOblast]: 'EKATERINBURG',
    [Regions.UGRA]: 'UGRA',
    [Regions.NRIC]: 'NRIC'
}

// date-fns-tz
export const regionTimezones: Record<Regions, string> = {
    [Regions.TjumenskajaOblast]: 'Asia/Yekaterinburg',
    [Regions.OrenburgskajaOblast]: 'Asia/Yekaterinburg',
    [Regions.Surgut]: 'Asia/Yekaterinburg',
    [Regions.JaNAO]: 'Asia/Yekaterinburg',
    [Regions.KurganskajaOblast]: 'Asia/Yekaterinburg',
    [Regions.SverdlovskajaOblast]: 'Asia/Yekaterinburg',
    [Regions.UGRA]: 'Asia/Yekaterinburg',
    [Regions.NRIC]: 'Asia/Yekaterinburg',
}

export enum ContragentCodeGroups {
    NONE = 0,
    OTSK = 1,
}
